import { gameNameForUrl } from './gameConfigsAndUrls';

export const RoutePaths = {
  game: `/${gameNameForUrl}/`,
  replay: `/replay`,
};
